import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { getCompanies as retrieveCompanies } from "actions/company";
import { getRequests as getAccessRequests } from "actions/companyAccessRequest";
import { getSignedUpUser, logoutUser, saveUser } from "actions/user";
import { replace } from "connected-react-router";
import PropTypes from "prop-types";
import { currentUserShape } from "shapes";

import history from "utils/history";
import { isIos } from "utils/isMobileDevice";
import { getUrlParams } from "utils/urlParams";

import { ExistingCompany, NewCompany } from ".";

const unmountEvent = isIos() ? "pagehide" : "beforeunload";

class Company extends React.Component {
  constructor(props) {
    super(props);

    this.cleanup = this.cleanup.bind(this);
  }

  componentDidMount() {
    const { confirmEmail, getCompanies, getRequests, getUser, location, redirectTo } = this.props;

    getUser(getUrlParams()).then((u) =>
      getCompanies().then((c) => {
        const { user } = u.value;
        const { companies } = c.value;

        if (user.company) redirectTo("/");
        if (!user.emailConfirmedAt) confirmEmail(user);
        if (companies.length > 0 && companies[0].id) getRequests(companies[0].id);

        if (location.pathname === "/signup/account") {
          return companies.length > 0
            ? redirectTo("/signup/account/existing")
            : redirectTo("/signup/account/new");
        }

        return null;
      })
    );

    window.addEventListener(unmountEvent, this.cleanup);
  }

  componentWillUnmount() {
    this.cleanup();
    window.removeEventListener(unmountEvent, this.cleanup);
  }

  cleanup() {
    const { currentUser, logout } = this.props;
    if (!currentUser.company || !currentUser.company.id) logout();
  }

  render() {
    return (
      <Switch>
        <Route component={ExistingCompany} path="/signup/account/existing" />
        <Route component={NewCompany} path="/signup/account/new" />
      </Switch>
    );
  }
}

Company.propTypes = {
  confirmEmail: PropTypes.func.isRequired,
  currentUser: PropTypes.shape(currentUserShape),
  getCompanies: PropTypes.func.isRequired,
  getRequests: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  logout: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired,
};

const mapStateToProps = ({ currentUser, router: { location } }) => ({
  currentUser,
  location,
});

const mapDispatchToProps = (dispatch) => ({
  confirmEmail: ({ id }) =>
    dispatch(
      saveUser({
        user: { id, emailConfirmedAt: new Date().toISOString() },
      })
    ),
  getCompanies: () => dispatch(retrieveCompanies()),
  getRequests: (id) => dispatch(getAccessRequests(id)),
  getUser: ({ email, invite_token }) => dispatch(getSignedUpUser(email, invite_token)), // eslint-disable-line
  logout: () => dispatch(logoutUser(false)),
  redirectTo: (url) => dispatch(replace(`${url}${history.location.search}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Company);
